import { forwardRef } from "react";
import { NumericFormat } from "react-number-format";
import PropTypes from "prop-types";

const CustomNumberFormat = forwardRef(function NumberFormatCustom(
  { onChange, ...other },
  ref
) {
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: other.name,
            value: values.floatValue ?? "",
          },
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
    />
  );
});

CustomNumberFormat.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default CustomNumberFormat;
